<template>
  <form class="column is-12" @submit.prevent="onSubmit">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">Seleccione la ubicación</h3>
      </div>
      <div class="column is-7">
        <div class="field">
          <label for="state" class="label">Seleccione la ubicación</label>
          <div class="select is-fullwidth">
            <select name="type" id="state" v-model="location">
              <option v-for="option of stateOptions" v-bind:value='option.departamento' :key='option.departamento'>
                {{option.departamento}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <button class="button is-black" :disabled="!location">Continuar</button>
      </div>
    </div>
  </form>
</template>

<script>
import states from '../../../../assets/data/states.json';

export default {
  name: "StateIdentification",
  computed: {
    stateOptions() {
      return states;
    }
  },
  data() {
    return {
      location: ''
    }
  },
  methods: {
    onSubmit() {
      this.$emit('done', {
        key: 'stateIdentification',
        location: this.location
      });
    }
  }
}
</script>
